module.exports = __webpack_public_path__ + "img/print.6d478311.svg";